import { datadogRum } from "@datadog/browser-rum";
import { getAppVariable } from "@white-label-helper/get-app-variable";

export type MetricContext = Record<string, string | number | undefined | Error | null>;

export const addCustomMetric = (metricType: 'tracking' | 'error', name: string, context: MetricContext, startTime: number | null, contextKey: string, airportCode?: string | undefined) => {
	const metricContext = typeof context === 'object' && context !== null ? context : {};
	const endTime = performance.now();
	const duration = startTime ? (endTime - startTime) / 1000 : null;

	if (metricType === 'tracking') {
		datadogRum.addAction(name, {
			[contextKey]: {
				...metricContext,
				env: process.env['NODE_ENV'] === 'production' ? 'live' : 'dev',
				channel_id: getAppVariable('channel').id,
				...(startTime && { duration_in_seconds: duration?.toFixed(2) }),
				airport_code: airportCode ? airportCode : getAppVariable('poi').code,
			}
		});
	}

	if (metricType === 'error') {
		datadogRum.addError(name, {
			[contextKey]: {
				...metricContext,
				env: process.env['NODE_ENV'] === 'production' ? 'live' : 'dev',
				channel_id: getAppVariable('channel').id,
				...(startTime && { duration_in_seconds: duration?.toFixed(2) }),
				airport_code: airportCode ? airportCode : getAppVariable('poi').code,
			}
		});
	}
}
